const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

export function getBackendUrl() {
  if (!backendUrl) {
    throw new Error("REACT_APP_BACKEND_URL is required");
  }
  return backendUrl.replace(/\/+$/, "");
}

export const API_BASE = `${getBackendUrl()}/api`;
